import React, { useMemo } from 'react';
import Text, { TextSize } from '@move-ui/text';
import cx from 'classnames';
import styles from './PriceRatingScale.module.css';
export var PriceRating;
(function (PriceRating) {
    PriceRating["Great"] = "GREAT";
    PriceRating["Good"] = "GOOD";
    PriceRating["Fair"] = "FAIR";
    PriceRating["Poor"] = "POOR";
})(PriceRating || (PriceRating = {}));
const PriceRatingScale = ({ rating, className, greatMessage, goodMessage, fairMessage, poorMessage }) => {
    const ratingData = useMemo(() => [
        {
            id: PriceRating.Great,
            className: 'great',
            label: greatMessage
        },
        {
            id: PriceRating.Good,
            className: 'good',
            label: goodMessage
        },
        {
            id: PriceRating.Fair,
            className: 'fair',
            label: fairMessage
        },
        {
            id: PriceRating.Poor,
            className: 'poor',
            label: poorMessage
        }
    ], [greatMessage, goodMessage, fairMessage, poorMessage]);
    return (React.createElement("div", { "data-testid": "PriceRatingScale", className: cx(styles.component, className) }, ratingData.map(({ id, className: ratingClassName, label }) => {
        const isSelected = rating === id;
        const textProps = isSelected
            ? {
                bold: true,
                color: 'neutral-100'
            }
            : {
                color: 'neutral-200'
            };
        return (React.createElement("div", { key: label, "data-testid": isSelected ? 'rating-bar-selected' : '', className: cx(styles.rating, {
                [styles.selected]: isSelected
            }) },
            React.createElement("div", { className: cx(styles.bar, styles[ratingClassName]) }),
            React.createElement(Text, Object.assign({ size: TextSize.XS }, textProps), label)));
    })));
};
export default PriceRatingScale;
//# sourceMappingURL=PriceRatingScale.js.map